// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessage_message_3Q5Dw"};